module.exports = __webpack_public_path__ + "static/img/img10.54689b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img10.png
// module id = BYd3
// module chunks = 0